"use strict";var r=require("tslib");exports.arrayFlatMap=function(a,e){return a.reduce((function(a){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];return r.__spreadArray(r.__spreadArray([],a,!0),e.apply(void 0,t),!0)}),[])};
//# sourceMappingURL=arrayFlatMap.cjs.map
